import '../styles/navbar1.css';

import { NavLink } from 'react-router-dom';
import React from 'react';

const Navbar1 = () => {
  return (
    <div className="navbar1">
      <div className="navbarWrapper1">
        <div className="navBarLeft1">
          <NavLink to="/" className="static">
            James L. Avakian
          </NavLink>
        </div>
        <div className="navbarRight1">
          <div className="navMenu1">
            <NavLink to="/home" className={`navMenuItem1`}>
              Home
            </NavLink>

            <NavLink to="/products" className={`navMenuItem1`}>
              Products
            </NavLink>
            <NavLink to="/software" className={`navMenuItem1`}>
              Software
            </NavLink>
            {/* <NavLink to="/technology" className={`navMenuItem`}>
              Technology
            </NavLink> */}

            <NavLink to="/roadmap" className={`navMenuItem1`}>
              Roadmap
            </NavLink>
            <NavLink to="/news" className={`navMenuItem1`}>
              News
            </NavLink>

            {/* {!walletAddress && !user && (
              <>
                <i className="fas fa-user-circle navAvatar navMenuItem"></i>
                <div
                  className="navMenuItem loginBtn"
                  onClick={() => handleAuth(connectWallet)}
                >
                  Login
                </div>
              </>
            )}

            {walletAddress && !user && (
              <>
                <i className="fas fa-user-circle navAvatar navMenuItem"></i>
                <div
                  className="navMenuItem loginBtn"
                  onClick={() => handleAuth(connectWallet)}
                >
                  Login
                </div>
              </>
            )}

            {!walletAddress && user && (
              <>
                <i className="fas fa-user-circle navAvatar navMenuItem"></i>
                <div
                  className="navMenuItem loginBtn"
                  onClick={() => handleAuth(connectWallet)}
                >
                  Connect Wallet
                </div>
              </>
            )}

            {walletAddress && user && (
              <>
                <i className="fas fa-user-circle navAvatar navMenuItem"></i>
                <div
                  className="navMenuItem loginBtn"
                  onClick={() => handleLogout(disconnectWallet)}
                >
                  Logout
                </div>
              </>
            )} */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar1;
